import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { I18nextProvider } from 'react-i18next';
import { QueryClientProvider } from '@tanstack/react-query';
import i18n from './i18n/index.ts';
import { crearQueryClient } from './api/queries.ts';
import { AuthProvider } from './features/auth/AuthProvider.tsx';
import { AppRoutes } from './app/routes.tsx';
import './styles/global.css';

const queryClient = crearQueryClient();

/**
 * Solo en DESARROLLO: el cliente de consultas, al alcance del recorrido E2E.
 *
 * Hace falta para probar la animación de cambio de puesto, que por definición necesita
 * que los datos se REFRESQUEN sin desmontar la pantalla. Navegar y volver no sirve: eso
 * remonta el componente y vuelve a ser "primera carga", que es justo el caso que NO anima.
 *
 * `import.meta.env.DEV` es una constante que Vite sustituye al compilar, así que esta
 * rama entera desaparece del paquete de producción. No hay superficie que exponer.
 */
if (import.meta.env.DEV) {
  (window as unknown as { __queryClient?: unknown }).__queryClient = queryClient;
}

const root = document.getElementById('root');
if (!root) throw new Error('Falta el nodo #root en index.html');

createRoot(root).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          {/* AuthProvider por dentro del QueryClientProvider: al cerrar sesión hay que
              vaciar la caché, y para eso necesita acceso al cliente de consultas. */}
          <AuthProvider queryClient={queryClient}>
            <AppRoutes />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </I18nextProvider>
  </StrictMode>,
);
